import { useMutation } from "react-query";
import { endpoints } from "utils/endpoints";
import http from "utils/http";

const tailoredQuote = (postData) => {
  return http().post(endpoints.forms.tailoredQuote, postData);
};

export function useTailoredQuote() {
  return useMutation(tailoredQuote, {
    onError: (errorData) => {
      const errorMessage = errorData?.error?.message || errorData?.message;
      alert(errorMessage);
    },
  });
}
